import { NgModule, ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, INJECTOR, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ConcilioServiceApi } from '@conciliome/concilio-core';
import { map } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
class B2bApiModule {
}
B2bApiModule.ɵfac = function B2bApiModule_Factory(t) { return new (t || B2bApiModule)(); };
B2bApiModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: B2bApiModule });
B2bApiModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(B2bApiModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2bApiModule, { imports: function () { return [CommonModule]; } }); })();

class ArticleApiService {
    constructor(environment, httpClient) {
        this.environment = environment;
        this.httpClient = httpClient;
        this.migrationUrl = '';
        this.baseUrl = '';
        this.endPoint = 'endPoint';
        if (!this.environment) {
            this.logger.logError('Environment Injection token missing inside app.module', 'You must specify an injection token from "environment" value');
        }
        else {
            this.baseUrl = this.environment.strapiBaseUrl;
            this.url = this.baseUrl + this.endPoint;
        }
    }
    find() {
        return this.httpClient.get(this.baseUrl + '/articles');
    }
}
ArticleApiService.ɵfac = function ArticleApiService_Factory(t) { return new (t || ArticleApiService)(ɵngcc0.ɵɵinject('environment'), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
ArticleApiService.ɵprov = ɵɵdefineInjectable({ factory: function ArticleApiService_Factory() { return new ArticleApiService(ɵɵinject("environment"), ɵɵinject(HttpClient)); }, token: ArticleApiService, providedIn: "root" });
ArticleApiService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] },
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ArticleApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['environment']
            }] }, { type: ɵngcc1.HttpClient }]; }, null); })();

class B2bMeetingsService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/lead-meetings', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    createContact(contact) {
        return this.httpClient.post(`${this.url}/contact`, contact);
    }
    get(fromDate, toDate) {
        return this.httpClient.get(`${this.url}/availability/${fromDate}/${toDate}`);
    }
    bookSlot(data) {
        return this.httpClient.post(`${this.url}/book`, data);
    }
}
B2bMeetingsService.ɵfac = function B2bMeetingsService_Factory(t) { return new (t || B2bMeetingsService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
B2bMeetingsService.ɵprov = ɵɵdefineInjectable({ factory: function B2bMeetingsService_Factory() { return new B2bMeetingsService(ɵɵinject(INJECTOR)); }, token: B2bMeetingsService, providedIn: "root" });
B2bMeetingsService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(B2bMeetingsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class HomepageApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/homepage', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    get() {
        return this.httpClient.get(this.url);
    }
}
HomepageApiService.ɵfac = function HomepageApiService_Factory(t) { return new (t || HomepageApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
HomepageApiService.ɵprov = ɵɵdefineInjectable({ factory: function HomepageApiService_Factory() { return new HomepageApiService(ɵɵinject(INJECTOR)); }, token: HomepageApiService, providedIn: "root" });
HomepageApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HomepageApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class AdvantageTypeApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/pricing-advantage-types', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    getList() {
        return this.httpClient.get(this.url);
    }
}
AdvantageTypeApiService.ɵfac = function AdvantageTypeApiService_Factory(t) { return new (t || AdvantageTypeApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
AdvantageTypeApiService.ɵprov = ɵɵdefineInjectable({ factory: function AdvantageTypeApiService_Factory() { return new AdvantageTypeApiService(ɵɵinject(INJECTOR)); }, token: AdvantageTypeApiService, providedIn: "root" });
AdvantageTypeApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AdvantageTypeApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class MoreApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/more', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    get() {
        return this.httpClient.get(this.url);
    }
}
MoreApiService.ɵfac = function MoreApiService_Factory(t) { return new (t || MoreApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
MoreApiService.ɵprov = ɵɵdefineInjectable({ factory: function MoreApiService_Factory() { return new MoreApiService(ɵɵinject(INJECTOR)); }, token: MoreApiService, providedIn: "root" });
MoreApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MoreApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class FooterApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/footer', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    get() {
        return this.httpClient.get(this.url);
    }
}
FooterApiService.ɵfac = function FooterApiService_Factory(t) { return new (t || FooterApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
FooterApiService.ɵprov = ɵɵdefineInjectable({ factory: function FooterApiService_Factory() { return new FooterApiService(ɵɵinject(INJECTOR)); }, token: FooterApiService, providedIn: "root" });
FooterApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FooterApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class HeaderApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/header', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    get() {
        return this.httpClient.get(this.url);
    }
}
HeaderApiService.ɵfac = function HeaderApiService_Factory(t) { return new (t || HeaderApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
HeaderApiService.ɵprov = ɵɵdefineInjectable({ factory: function HeaderApiService_Factory() { return new HeaderApiService(ɵɵinject(INJECTOR)); }, token: HeaderApiService, providedIn: "root" });
HeaderApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class B2bServicesApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/services', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    get() {
        return this.httpClient.get(this.url);
    }
}
B2bServicesApiService.ɵfac = function B2bServicesApiService_Factory(t) { return new (t || B2bServicesApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
B2bServicesApiService.ɵprov = ɵɵdefineInjectable({ factory: function B2bServicesApiService_Factory() { return new B2bServicesApiService(ɵɵinject(INJECTOR)); }, token: B2bServicesApiService, providedIn: "root" });
B2bServicesApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(B2bServicesApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class B2bGarantiesApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/garanties', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    get() {
        return this.httpClient.get(this.url);
    }
}
B2bGarantiesApiService.ɵfac = function B2bGarantiesApiService_Factory(t) { return new (t || B2bGarantiesApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
B2bGarantiesApiService.ɵprov = ɵɵdefineInjectable({ factory: function B2bGarantiesApiService_Factory() { return new B2bGarantiesApiService(ɵɵinject(INJECTOR)); }, token: B2bGarantiesApiService, providedIn: "root" });
B2bGarantiesApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(B2bGarantiesApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class B2bLivreBlancApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/livre-blanc', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    getPage() {
        return this.httpClient.get(this.url);
    }
    getList() {
        return this.httpClient.get(`${this.baseUrl}/livre-blanc-details`);
    }
}
B2bLivreBlancApiService.ɵfac = function B2bLivreBlancApiService_Factory(t) { return new (t || B2bLivreBlancApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
B2bLivreBlancApiService.ɵprov = ɵɵdefineInjectable({ factory: function B2bLivreBlancApiService_Factory() { return new B2bLivreBlancApiService(ɵɵinject(INJECTOR)); }, token: B2bLivreBlancApiService, providedIn: "root" });
B2bLivreBlancApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(B2bLivreBlancApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class B2bPricingApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/pricing', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    get() {
        return this.httpClient.get(this.url);
    }
}
B2bPricingApiService.ɵfac = function B2bPricingApiService_Factory(t) { return new (t || B2bPricingApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
B2bPricingApiService.ɵprov = ɵɵdefineInjectable({ factory: function B2bPricingApiService_Factory() { return new B2bPricingApiService(ɵɵinject(INJECTOR)); }, token: B2bPricingApiService, providedIn: "root" });
B2bPricingApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(B2bPricingApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class B2bTemoignagnesApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/enjeux-rh', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    get() {
        return this.httpClient.get(this.url);
    }
    getById(id) {
        return this.httpClient.get(`${this.baseUrl}/temoignages/${id}`);
    }
}
B2bTemoignagnesApiService.ɵfac = function B2bTemoignagnesApiService_Factory(t) { return new (t || B2bTemoignagnesApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
B2bTemoignagnesApiService.ɵprov = ɵɵdefineInjectable({ factory: function B2bTemoignagnesApiService_Factory() { return new B2bTemoignagnesApiService(ɵɵinject(INJECTOR)); }, token: B2bTemoignagnesApiService, providedIn: "root" });
B2bTemoignagnesApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(B2bTemoignagnesApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class PageSeoApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/page-seos', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    find() {
        return this.httpClient.get(`${this.baseUrl}/page-seos`);
    }
}
PageSeoApiService.ɵfac = function PageSeoApiService_Factory(t) { return new (t || PageSeoApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
PageSeoApiService.ɵprov = ɵɵdefineInjectable({ factory: function PageSeoApiService_Factory() { return new PageSeoApiService(ɵɵinject(INJECTOR)); }, token: PageSeoApiService, providedIn: "root" });
PageSeoApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageSeoApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class B2bTunnelsApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/tunnels', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    get() {
        return this.httpClient.get(this.url);
    }
}
B2bTunnelsApiService.ɵfac = function B2bTunnelsApiService_Factory(t) { return new (t || B2bTunnelsApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
B2bTunnelsApiService.ɵprov = ɵɵdefineInjectable({ factory: function B2bTunnelsApiService_Factory() { return new B2bTunnelsApiService(ɵɵinject(INJECTOR)); }, token: B2bTunnelsApiService, providedIn: "root" });
B2bTunnelsApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(B2bTunnelsApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class CtaApiService extends ConcilioServiceApi {
    constructor(injector) {
        super(injector, '/ctas', '');
        this.baseUrl = this._environment.strapiBaseUrl;
        this.url = this.baseUrl + this.endPoint;
    }
    get() {
        return this.httpClient.get(this.url);
    }
    getCtaSeo() {
        return this.get().pipe(map((ctas) => ctas.find((cta) => cta.slug === 'cta-seo')));
    }
}
CtaApiService.ɵfac = function CtaApiService_Factory(t) { return new (t || CtaApiService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
CtaApiService.ɵprov = ɵɵdefineInjectable({ factory: function CtaApiService_Factory() { return new CtaApiService(ɵɵinject(INJECTOR)); }, token: CtaApiService, providedIn: "root" });
CtaApiService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CtaApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

/*
 * Public API Surface of b2b-api
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdvantageTypeApiService, ArticleApiService, B2bApiModule, B2bGarantiesApiService, B2bLivreBlancApiService, B2bMeetingsService, B2bPricingApiService, B2bServicesApiService, B2bTemoignagnesApiService, B2bTunnelsApiService, CtaApiService, FooterApiService, HeaderApiService, HomepageApiService, MoreApiService, PageSeoApiService };

